<template>
  <div class="auth">
    <div v-if="!isAuthorized" class="auth-block">
      <h2>Вход</h2>
      <p>Введите данные для входа в систему</p>
      <form @submit.prevent="submit">
        <div class="input-wrap" :class="{ 'input-wrap-error': $v.login.$error }">
          <input class="form-control" v-model="$v.login.$model" type="text" placeholder="E-mail">
          <span class="error" v-if="!$v.login.required">Это обязательное поле</span>
          <!-- <span class="error" v-if="!$v.login.email">Неверный e-mail</span> -->
        </div>
        <div class="input-wrap" :class="{ 'input-wrap-error': $v.password.$error }">
          <input class="form-control" v-model="$v.password.$model" type="password" placeholder="Пароль">
          <span class="error" v-if="!$v.password.required">Это обязательное поле</span>
        </div>
        <button v-if="!isLoad" @click="loginSystem()" class="btn accent-btn">Вход</button>
        <div v-else class="bubbles">
          <div class="bubble">
            <div class="circle"></div>
          </div>
          <div class="bubble">
            <div class="circle"></div>
          </div>
          <div class="bubble">
            <div class="circle"></div>
          </div>
          <div class="bubble">
            <div class="circle"></div>
          </div>
          <div class="bubble">
            <div class="circle"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      login: '',
      password: '',
      submitStatus: null,
      isLoad: false
    }
  },
  validations: {
    login: {
      required
    },
    password: {
      required
    }
  },
  computed: {
    isAuthorized () {
      return this.$store.getters.value('isAuthorized')
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }
    },
    loginSystem () {
      this.isLoad = true
      this.getRefreshToken(this.login, this.password).then(response => {
        this.$cookies.set('refresh', response.data.token)
        this.getAccessToken().then(response => {
          axios.defaults.headers.common['Authorization'] = 'JWT ' + response.data.token
          this.$cookies.set('access', response.data.token)
          this.setUserInfoMix(response.data.token)
          this.$store.dispatch('SET_VALUE', {key: 'isAuthorized', value: true})
          this.$router.push('/')
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Авторизация',
            text: 'Вы успешно авторизовались!'
          })
        }).catch(error => {
          this.isLoad = false
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Авторизация',
            text: 'Ошибка при входе!'
          })
          console.log(error)
        })
      }).catch(error => {
        this.isLoad = false
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Авторизация',
          text: 'Ошибка при входе!'
        })
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.bubbles {
  margin-top: 40px;
  position: relative;
}

.bubble {
  display: inline-block;
  padding: 0px 2px;
  @for $i from 1 to 6 {
    &:nth-of-type(#{$i}) .circle {
      animation-delay: $i * 0.2s;
    }
  }
}

.bubble .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #4E53E7;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(0.2); opacity:0.75; }
  100% { transform: scale(1); }
}

.auth {
  position: absolute;
  top: 67px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 999;
  &-block {
    width: 450px;
    max-width: 100%;
    padding: 30px 60px;
    border-radius: 10px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
    margin: 50px auto 0;
    text-align: center;
    h2 {
      margin-bottom: 15px;
    }
    p {
      margin-bottom: 15px;
    }
    .input-wrap {
      margin-bottom: 20px;
      text-align: left;
      span {
        display: none;
        margin-top: 5px;
        font-size: 10px;
        color: red;
      }
      &-error {
        .form-control {
          border-color: red
        }
        span {
          display: inline-block;
        }
      }
    }
    .form-control {
      font-size: 13px;
      height: 40px;
      display: block;
      width: 100%;
    }
    .btn {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/AuthorizationVue.vue